import React from 'react';
import { Badge } from './ui/badge';
import { Users, Globe, Award, Heart } from 'lucide-react';
import { aboutInfo } from '../data/staticData';

const About = () => {
  const features = [
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Passionate travel experts dedicated to creating perfect vacations'
    },
    {
      icon: Globe,
      title: 'Global Network',
      description: 'Partnerships with premium resorts and hotels worldwide'
    },
    {
      icon: Award,
      title: 'Award-Winning',
      description: 'Recognized for excellence in luxury travel services'
    },
    {
      icon: Heart,
      title: 'Personalized Care',
      description: '24/7 support ensuring every detail exceeds expectations'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white via-orange-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-orange-100 text-orange-700 hover:bg-orange-200 mb-4">
            About Us
          </Badge>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {aboutInfo.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {aboutInfo.description}
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
          {aboutInfo.stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center border border-[#e4e2de]"
            >
              <p className="text-5xl font-bold bg-gradient-to-r from-[#ef571b] to-[#dc4f42] bg-clip-text text-transparent mb-2">
                {stat.value}
              </p>
              <p className="text-gray-600 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center group"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#ef571b] to-[#dc4f42] rounded-2xl mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="mt-20 rounded-3xl overflow-hidden shadow-2xl">
          <img
            src="https://images.unsplash.com/photo-1567636636276-40a47795ba4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZXNvcnR8ZW58MHx8fHwxNzYwNjU4MTU1fDA&ixlib=rb-4.1.0&q=85"
            alt="Luxury Resort"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default About;